import ScreenWrapper from "@/components/ScreenWrapper"
import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute("/dashboard/")({
  component: RouteComponent,
})

function RouteComponent() {
  return <ScreenWrapper showManagementMenu>Dashboard</ScreenWrapper>
}
